/**
 * The tab's icon on a tenant's pages: the workspace's own logo when one is
 * uploaded, else a small crest drawn from its initials on its accent colour.
 * Never Flashroom's own mark; these pages are the host's, not ours.
 */

/** Two letters for a name: "Jane Realty" is JR, "Flashkut" is FL. */
export function crestLetters(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const letters =
    words.length >= 2 ? words[0][0] + words[1][0] : (words[0] ?? "").slice(0, 2);
  return letters.toUpperCase() || "FW";
}

/** A rounded square in the accent with the crest on it, as a data address. */
export function crestIcon(letters: string, accent: string): string {
  const safe = letters.replace(/[^A-Za-z0-9]/g, "").slice(0, 2) || "FW";
  const fill = /^#[0-9a-fA-F]{3,8}$/.test(accent) ? accent : "#7a2338";
  const size = safe.length === 1 ? 20 : 15;
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">` +
    `<rect width="32" height="32" rx="8" fill="${fill}"/>` +
    `<text x="16" y="21.5" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" font-size="${size}" font-weight="700" fill="#fff">${safe}</text>` +
    `</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

/** The address the icon links point at for this brand. */
export function brandIconHref(brand: { logo_url: string | null; crest: string; accent: string }): string {
  return brand.logo_url || crestIcon(brand.crest, brand.accent);
}
